import { KeyboardEvent, MouseEvent } from 'react';
import { MdClose } from 'react-icons/md';
import { FormOption } from 'types';
import { Text } from 'components';
import { FontWeight } from 'commons';
import * as S from './styles';
import { useSelect } from '../../hooks';

interface TagsProps {
  maxTags?: number;
}

export function Tags({ maxTags = 3 }: TagsProps) {
  const { tagList, setTagList } = useSelect();

  if (!Boolean(tagList.length)) return null;

  function removeTag(tagToRemove: FormOption) {
    const newTagList = tagList.filter((oldTag: any) => {
      return oldTag.value !== tagToRemove.value;
    });

    setTagList(newTagList);
  }

  let overflowTagsLength = 0;

  const renderTags = tagList
    .flat()
    .reverse()
    .filter((_, index) => {
      if (index >= maxTags) {
        overflowTagsLength = index - maxTags + 1;

        return false;
      }

      return true;
    })
    .map((tag) => {
      return (
        <S.Tag key={tag.value}>
          <Text weight={FontWeight.bold}>{tag.label}</Text>

          <S.RemoveButton
            tabIndex={0}
            aria-label="button"
            onClick={(event: MouseEvent) => {
              event.stopPropagation();

              removeTag(tag);
            }}
            onKeyDown={(event: KeyboardEvent) => {
              event.stopPropagation();

              const key = event?.key?.toLowerCase();

              if (key === 'enter') {
                removeTag(tag);
              }
            }}
          >
            <MdClose size={16} />
          </S.RemoveButton>
        </S.Tag>
      );
    });

  return (
    <S.Wrapper>
      {renderTags}

      {Boolean(overflowTagsLength) && (
        <S.Tag $isSummary>
          <Text weight={FontWeight.bold}>+ {overflowTagsLength}</Text>
        </S.Tag>
      )}
    </S.Wrapper>
  );
}
